import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const resendInvite = (userId: string) => {
  return axiosPrivate.post(`/dashboard/v1/staff_management/${userId}/resent_invite`);
};